import { Core } from 'chessboard/core/config/types';
import { FlipBoard } from 'chessboard/plugins/flip-board/config/types';
import { is } from 'utils/app/model/is';
import { isOneOf } from 'utils/app/model/is-one-of';
import { Keys } from 'chessboard/plugins/keys/config/types';
import type { Plugins } from 'chessboard/core/plugins/config/types';

/**
 * Adds commands for updating assets in response to options changes.
 */
export function createFlipBoardPlugin(
  flipKeyModifier = FlipBoard.FlipBoardModifierKey,
): Plugins.Model {
  let flipped: boolean;

  return {
    match: [
      {
        condition: isOneOf([
          Core.InstanceEvents.Create,
          Core.InstanceEvents.RendererSet,
          Core.OptionsEvents.Update,
        ]),
        handler: runFlipBoardPlugin,
      },
      {
        condition: is(Keys.Events.Keydown),
        handler: onKeydown,
      },
    ],
    name: FlipBoard.Plugin.Name,
  };

  /**
   * Handle keydown event.
   */
  function onKeydown(event: Core.Event, context: Core.Context) {
    const { api, options, queue } = context;

    if (event.data.key !== flipKeyModifier || options.isSiblingBoard) {
      return;
    }

    queue.add(api.setOptions, { flipped: !options.flipped });
  }

  /**
   * Run.
   */
  function runFlipBoardPlugin(_event: Core.Event, context: Core.Context) {
    const { options, renderer, state } = context;

    if (!renderer) {
      return;
    }

    if (options.flipped !== flipped) {
      renderer.flipBoard(options.flipped, context);

      const promotionMove = state.get(Core.State.PromotionMove);

      if (promotionMove) {
        // re-render the promotion window if the board is flipped while promoting
        renderer.openPromotionWindow(promotionMove, context);
      }
    }

    flipped = options.flipped;
  }
}
